
<div class="right-side p-5">
  <form [formGroup]="viewEventForm">
    <!--<h2>Event Created List</h2>-->
    <h2 class="mb-2">Event Details</h2>
    <div class="row section">
      <!-- Total Registration Card -->
      <!--<div class="col-md-4">
      <div class="card bg-gradient-primary box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5"> Total Event</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{ totalEvent }}</div>
            <i class="bi bi-calendar ms-auto fs-5"></i>
          </div>
          <p class="card-text fnts">Total No. of event received.</p>
        </div>
      </div>
    </div>-->

      <!-- Pending for Verification Card -->
      <!--<div class="col-md-4">
      <div class="card bg-gradient-warning box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5">Completed Event</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{ approvedEvent }}</div>
            <i class="bi bi-check-circle ms-auto fs-5"></i>
          </div>
          <p class="card-text fnts">No. of event awaiting verification.</p>
        </div>
      </div>
    </div>-->
      <!-- Approved Registration Card -->
      <!--<div class="col-md-4">
      <div class="card bg-gradient-success box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5"> Upcomming Event</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{ pendingEvent }}</div>
            <i class="bi bi-calendar-week ms-auto fs-5"></i>
          </div>
          <p class="card-text fnts">No. of event that have been approved.</p>
        </div>
      </div>
    </div>-->
      <!--<div class="row mb-1 text-center">
      <div class="col-md-12">
        <button type="submit" class="btn btn btn-primary" (click)="onListView()">List View</button>
        <button type="submit" class="btn btn btn-primary mx-1" (click)="onCalenderView()">Calender View</button>
        <button type="submit" class="btn btn btn-primary" (click)="onCardView()">Card View</button>
      </div>
    </div>-->

      <div class="row mb-1">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary mt-1" (click)="onListView()">
            <i class="fas fa-list"></i> List View
          </button>
          <button type="submit" class="btn btn-primary mx-1 mt-1" (click)="onCalenderView()">
            <i class="fas fa-calendar-alt"></i> Calendar View
          </button>
          <button type="submit" class="btn btn-primary mt-1" (click)="onCardView()">
            <i class="fas fa-th-large"></i> Card View
          </button>
        </div>
      </div>

      <!--<div class="text-end mb-2">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>-->
        <!--<button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>-->
      <!--</div>-->
      <hr />

      <div *ngIf="currentView === 'list'">
        <!--SEARCH-->
        <div class="col-lg-12 col-sm-12">

          <div class="search-container">
            <div class="d-flex align-items-center flex-wrap gap-3">



              <!-- From Date -->
              <mat-form-field appearance="outline" class="mb-2 flex-grow-1" style="max-width: 200px;">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker (closed)="onDateChange()"></mat-datepicker>
              </mat-form-field>

              <!-- To Date -->
              <mat-form-field appearance="outline" class="mb-2 flex-grow-1" style="max-width: 200px;">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="toDate"
                       [min]="viewEventForm.get('fromDate')?.value" readonly>
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker (closed)="onDateChange()"></mat-datepicker>
              </mat-form-field>


              <!-- Search -->
              <mat-form-field class="search-input flex-grow-1 mb-2" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="searchControl" />
              </mat-form-field>

              <!-- Search Button -->
              <button class="btn btn-outline-secondary p-2 mx-1 mb-2" type="submit"
                      (click)="onSearchClick(viewEventForm.get('searchControl')?.value ?? '')" id="btnSearch">
                <i class="bi bi-search"></i>
              </button>
              <!-- Reset Button -->
              <button class="btn btn-outline-secondary p-2 mb-2" type="reset" (click)="resetPage()" id="btnReset">
                <i class="bi bi-arrow-clockwise"></i>
              </button>
              <div style="display: flex; gap: 10px;">
                <button class="btn btn-primary"
                        [disabled]="viewEventForm.value.today"
                        (click)="onButtonClick('today')">
                  Today
                </button>

                <button class="btn btn-warning"
                        [disabled]="viewEventForm.value.tomorrow"
                        (click)="onButtonClick('tomorrow')">
                  Tomorrow
                </button>
                <button (click)="exportToExcel()" type="button" class="btn btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
              </div>
            </div>
            <!-- Validation Message -->
            <div *ngIf="viewEventForm.get('searchControl')?.invalid && (viewEventForm.get('searchControl')?.touched || viewEventForm.get('searchControl')?.dirty)">
              <small *ngIf="viewEventForm.get('searchControl')?.errors?.['pattern']" class="text-danger">
                Invalid search term.
              </small>
            </div>
          </div>
        </div>
        <!--<div class="col-lg-7 col-sm-12">
    <div class="search-container">
      <mat-form-field class="search-input w-75" appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput formControlName="search" />
      </mat-form-field>
      <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(viewEventForm.get('search')?.value ?? '')" id="btnSearch">
        <i class="bi bi-search fs-4"></i>
      </button>
      <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
        <i class="bi bi-arrow-clockwise fs-4"></i>
      </button>
    </div>
  </div>-->

        <div class="table-responsive" style="max-height:500px">
          <table mat-table [dataSource]="dataSource1" class="table table-striped table-bordered table-hover" matTableResponsive matSort matSortActive="eventDate" matSortDirection="desc" matSortDisableClear>
            <!--Sr.No Column-->
            <ng-container matColumnDef="serialNumber">
              <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
              <td mat-cell *matCellDef="let item"> {{ item.serialNumber }} </td>
            </ng-container>
            <!--EventId Column-->
            <ng-container matColumnDef="eventId">
              <th mat-header-cell *matHeaderCellDef> Event Id </th>
              <td mat-cell *matCellDef="let item">
                <a *ngIf="item.uniqueEventId" (click)="onEdit(item.uniqueEventId, item.proposalId)" class="text-primary no-underline" style="cursor: pointer !important;">
                  {{ item.eventId }}
                </a>
              </td>
            </ng-container>
            <!--Intervention Name Column-->
            <ng-container matColumnDef="interventionName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention Name </th>
              <td mat-cell *matCellDef="let item"> {{ item.interventionName }} </td>
            </ng-container>

            <!--Component Name Column-->
            <ng-container matColumnDef="componentName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Component Name </th>
              <td mat-cell *matCellDef="let item"> {{ item.componentName }} </td>
            </ng-container>
            <!--Event Name Column-->
            <ng-container matColumnDef="eventName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Name </th>
              <td mat-cell *matCellDef="let item"> {{ item.eventName }} </td>
            </ng-container>
            <!--Event Date Column-->
            <ng-container matColumnDef="eventDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Date </th>
              <td mat-cell *matCellDef="let item"> {{ item.formattedEventDate }} </td>
            </ng-container>
            <!--Time Column-->
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
              <td mat-cell *matCellDef="let item"> {{ item.time }} </td>
            </ng-container>
            <!--Event Status-->
            <ng-container matColumnDef="eventStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Status </th>
              <td mat-cell *matCellDef="let item"> {{ item.eventStatus }} </td>
            </ng-container>
            <!--Action Column-->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <!--<button mat-raised-button color="primary" *ngIf="item.uniqueEventId" (click)="onEdit(item.uniqueEventId, item.proposalId)">
        Edit
      </button>-->
                <button class="btn btn-primary btn-sm" *ngIf="item.uniqueEventId" (click)="onEdit(item.uniqueEventId, item.proposalId)">
                  <span *ngIf="checkDate(item.formattedEventDate); else viewText">Edit</span>
                  <ng-template #viewText>
                    <span><i class="bi bi-eye"></i> View</span>
                  </ng-template>
                </button>
              </td>
            </ng-container>
            <!--Live Event URL-->
            <ng-container matColumnDef="liveEventURL">
              <th mat-header-cell *matHeaderCellDef> Live Event URL </th>
              <td mat-cell *matCellDef="let item" class="text-center">

                <button class="btn btn-primary btn-sm" *ngIf="isBeforeTodayDate(item.formattedEventDate)" (click)="onLiveEventURLEdit(myPopup,item.uniqueEventId,item.eventStatus)">
                  <span><i class="{{ item.eventStatus === 'Completed' ? 'bi bi-eye' : 'bi bi-pencil' }}"></i>{{ item.eventStatus === 'Completed' ? 'View' : 'Update' }} </span>

                </button>
                <span *ngIf="!isBeforeTodayDate(item.formattedEventDate)"
                      class="text-warning d-block fw-semibold mt-1">
                  You can update the event URL starting one day before the event date.
                </span>
                <!--<span *ngIf="item.eventStatus === 'Completed'"
            class="text-danger d-block fw-bold mt-1">
        The event is completed; you can’t update the URL now.
      </span>-->

              </td>
            </ng-container>
            <!--Report Column-->
            <ng-container matColumnDef="report">
              <th mat-header-cell *matHeaderCellDef> Report </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <button class="btn btn-warning btn-sm text-white" *ngIf="isBeforeToday(item.formattedEventDate)" (click)="onOutputReport(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'">
                  <i class="bi bi-file-earmark-text"></i> <br />Output Report
                </button>
                <span *ngIf="!isBeforeToday(item.formattedEventDate)" style="color: red; font-weight: bold;">
                  Output report not yet available
                </span>
              </td>
            </ng-container>
            <!--Upload Column-->
            <ng-container matColumnDef="upload">
              <!--<th mat-header-cell *matHeaderCellDef> Upload </th>-->
              <th mat-header-cell *matHeaderCellDef> Attendance </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <!--item.eventStatus === 'Cancel'|| item.update === 'ViewDocumentsButton'-->
                <!--[disabled]="item.uniqueEventId !== '77588F06-4DDD-47D1-BB30-B45699E42278'"-->
                <!--<button class="btn btn-primary btn-sm mb-2" (click)="onMarkAttendance(item.uniqueEventId)" [disabled]="item.isAttendanceSubmitted === '1' || item.eventStatus === 'Cancel'|| (item.update === 'ViewDocumentsButton' && !allowedViewDocumentsButtonEventIds.includes(item.eventId))||!isEventDatePassed(item.eventDate)">-->
                  
                  
                  
                  <!-- <button class="btn btn-primary btn-sm mb-2" (click)="onMarkAttendance(item.uniqueEventId)" >

                    <i class="bi bi-upload"></i>
             Mark Attendance
                  </button> -->

                            <button class="btn btn-primary btn-sm mb-2" (click)="onMarkAttendance(item.uniqueEventId)" [disabled]="item.isAttendanceSubmitted === '1' || item.eventStatus === 'Cancel' || !isEventDatePassed(item.eventDate)">

                    <i class="bi bi-upload"></i>
                    Mark Attendance
                  </button>
                  <!--<button class="btn btn-primary btn-sm mb-2" (click)="onMarkAttendance(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'|| item.update === 'ViewDocumentsButton' ||!isEventDatePassed(item.eventDate)">
    <i class="bi bi-upload"></i>
    Mark Attendance
  </button>-->
                  <!--main-->
                  <!--<button class="btn btn-primary btn-sm mb-2" *ngIf="item.update === 'UpdateButton'" (click)="onUpdate(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'">
    <i class="bi bi-upload"></i>
    Upload Document
  </button>-->
                  <!--main ends-->
                  <!--<button class="btn btn-primary btn-sm mb-2" *ngIf="item.update === 'UpdateButton' || (item.update === 'Nothing' && (item.eventId === 'UBC_CB_80'|| item.eventId === 'LMC_CB_86'||item.eventId === 'EDII_CB_104'||item.eventId === 'SHE_CB_106'||item.eventId === 'SPTECH_CB_87'||item.eventId === 'SPTECH_CB_59'||item.eventId === 'SPTECH_CB_77'||item.eventId === 'PPDCAGRA_CB_91'||item.eventId === 'HARSHAL_CB_110'||item.eventId === 'SPTECH_CB_10'||item.eventId === 'PPDCAGRA_CB_24'||item.eventId === 'Justrojgar_CB_56'||item.eventId === 'SPTECH_CB_92'||item.eventId === 'SPTECH_CB_93'||item.eventId === 'SPTECH_CB_94'||item.eventId === 'SPTECH_CB_95'||item.eventId === 'SPTECH_CB_78' ||item.eventId === 'CCSPL_CB_120'||item.eventId === 'Justrojgar_CB_60'||item.eventId === 'Justrojgar_CB_65'||item.eventId === 'SHE_CB_90'||item.eventId === 'PPDCAGRA_CB_71'||item.eventId === 'PPDCAGRA_CB_33'))" (click)="onUpdate(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'">
    <i class="bi bi-upload"></i>
    Upload Document
  </button>-->
                   <button class="btn btn-primary btn-sm mb-2" *ngIf="item.update === 'UpdateButton' || (item.update === 'Nothing' && (item.eventId === 'UBC_CB_80'|| item.eventId === 'LMC_CB_86'||item.eventId === 'EDII_CB_104'||item.eventId === 'SHE_CB_106'||item.eventId === 'SPTECH_CB_87'||item.eventId === 'SPTECH_CB_59'||item.eventId === 'SPTECH_CB_77'||item.eventId === 'PPDCAGRA_CB_91'||item.eventId === 'HARSHAL_CB_110'||item.eventId === 'SPTECH_CB_10'||item.eventId === 'PPDCAGRA_CB_24'||item.eventId === 'Justrojgar_CB_56'||item.eventId === 'SPTECH_CB_92'||item.eventId === 'SPTECH_CB_93'||item.eventId === 'SPTECH_CB_94'||item.eventId === 'SPTECH_CB_95'||item.eventId === 'SPTECH_CB_78' ||item.eventId === 'CCSPL_CB_120'||item.eventId === 'Justrojgar_CB_60'||item.eventId === 'Justrojgar_CB_65'||item.eventId === 'SHE_CB_90'||item.eventId === 'PPDCAGRA_CB_71'||item.eventId === 'PPDCAGRA_CB_33'))" (click)="onUpdate(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'|| item.isAttendanceSubmitted === '0' ">
                    <i class="bi bi-upload"></i>
                    Upload Document
                  </button> 


                      <!-- <button class="btn btn-primary btn-sm mb-2" *ngIf="item.update === 'UpdateButton' || (item.update === 'Nothing' && (item.eventId === 'UBC_CB_80'|| item.eventId === 'LMC_CB_86'||item.eventId === 'EDII_CB_104'||item.eventId === 'SHE_CB_106'||item.eventId === 'SPTECH_CB_87'||item.eventId === 'SPTECH_CB_59'||item.eventId === 'SPTECH_CB_77'||item.eventId === 'PPDCAGRA_CB_91'||item.eventId === 'HARSHAL_CB_110'||item.eventId === 'SPTECH_CB_10'||item.eventId === 'PPDCAGRA_CB_24'||item.eventId === 'Justrojgar_CB_56'||item.eventId === 'SPTECH_CB_92'||item.eventId === 'SPTECH_CB_93'||item.eventId === 'SPTECH_CB_94'||item.eventId === 'SPTECH_CB_95'||item.eventId === 'SPTECH_CB_78' ||item.eventId === 'CCSPL_CB_120'||item.eventId === 'Justrojgar_CB_60'||item.eventId === 'Justrojgar_CB_65'||item.eventId === 'SHE_CB_90'||item.eventId === 'PPDCAGRA_CB_71'||item.eventId === 'PPDCAGRA_CB_33'))" (click)="onUpdate(item.uniqueEventId)"  >
                    <i class="bi bi-upload"></i>
                    Upload Document
                  </button> -->


                  <button class="btn btn-primary btn-sm mb-2" *ngIf="item.update === 'ViewDocumentsButton'" (click)="onViewEventDocs(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'">
                    <i class="bi bi-eye"></i>  View Document
                  </button>
                  <!--<span *ngIf="item.update === 'Nothing'" style="color: red; font-weight: bold;">
    Document upload is currently unavailable.
  </span>-->

                  <span *ngIf="item.update === 'Nothing' && !(item.eventId === 'UBC_CB_80'|| item.eventId === 'LMC_CB_86'||item.eventId === 'EDII_CB_104'||item.eventId === 'SHE_CB_106'||item.eventId === 'SPTECH_CB_87'||item.eventId === 'SPTECH_CB_59'||item.eventId === 'SPTECH_CB_77'||item.eventId === 'PPDCAGRA_CB_91'||item.eventId === 'HARSHAL_CB_110'||item.eventId === 'SPTECH_CB_10'||item.eventId === 'PPDCAGRA_CB_24'||item.eventId === 'Justrojgar_CB_56'||item.eventId === 'SPTECH_CB_92'||item.eventId === 'SPTECH_CB_93'||item.eventId === 'SPTECH_CB_94'||item.eventId === 'SPTECH_CB_95'||item.eventId === 'SPTECH_CB_78' ||item.eventId === 'CCSPL_CB_120' ||item.eventId === 'Justrojgar_CB_60' ||item.eventId === 'Justrojgar_CB_65'||item.eventId === 'SHE_CB_90'||item.eventId === 'PPDCAGRA_CB_71'||item.eventId === 'PPDCAGRA_CB_33')" style="color: red; font-weight: bold;">
                    Document upload is currently unavailable.
                  </span>

                  <span *ngIf="item.update === 'Done'" style="color: green; font-weight: bold;">
                    Document upload is done.
                  </span>
</td>
            </ng-container>
            <!--Spot Registration Column-->
            <!--<ng-container matColumnDef="spotRegistration">
    <th mat-header-cell *matHeaderCellDef> Spot Registration </th>
    <td mat-cell *matCellDef="let item" class="text-center">
      <button class="btn btn-primary" *ngIf="isDateToday(item.formattedEventDate)" (click)="onSpot(item.uniqueEventId)" [disabled]="item.eventStatus === 'Cancel'">
        <i class="bi bi-person-plus"></i> On Spot Registration
      </button>
      <span *ngIf="!isDateToday(item.formattedEventDate)" style="color: red; font-weight: bold;">
        Spot registration not yet available
      </span>
    </td>
  </ng-container>-->

            <ng-container matColumnDef="spotRegistration">
              <th mat-header-cell *matHeaderCellDef> Spot Registration </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <button class="btn btn-primary"
                        *ngIf="isSpotRegOpen(item.formattedEventDate, item.time)" (click)="onSpot(item, item.uniqueEventId)"
                        [disabled]="(item.eventStatus || '').toLowerCase() === 'cancel'">
                  <!--(click)="onSpot(item.uniqueEventId)"-->
                  <i class="bi bi-person-plus"></i> On Spot Registration
                </button>

                <span *ngIf="!isSpotRegOpen(item.formattedEventDate, item.time)"
                      style="color: red; font-weight: bold;">
                  Spot registration not available
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="viewEnrolledMSME">
              <th mat-header-cell *matHeaderCellDef> View Enrolled MSME </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <button class="btn btn-primary btn-sm" (click)="onViewEnrolledMSME(item.uniqueEventId)" *ngIf="item.enrolled>0;  else showDateMsg">
                  <i class="bi bi-eye"></i><br /> View Enrolled MSME
                </button>
                <ng-template #showDateMsg>
                  <span *ngIf="item.isEventDateGreaterThanToday;  else showEnrolledMsg" style="color: red; font-weight: bold;">
                    No MSME have enrolled
                  </span>
                </ng-template>
                <ng-template #showEnrolledMsg>
                  <span style="color: red; font-weight: bold;">
                    No MSME have enrolled
                  </span>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="viewAttendedMSME">
              <th mat-header-cell *matHeaderCellDef> View Attended MSME </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <button class="btn btn-primary btn-sm" (click)="onViewAttendedMSME(item.uniqueEventId)"
                        *ngIf="item.attendedcount>0;  else showNothing">
                  <i class="bi bi-eye"></i><br />View Attended MSME
                </button>
                <ng-template #showNothing>
                  <span *ngIf="item.isEventDateGreaterThanToday;  else showAttendedMsg" style="color: red; font-weight: bold;">
                    <!--Future Event-->
                  </span>
                </ng-template>
                <ng-template #showAttendedMsg>
                  <span style="color: red; font-weight: bold;" *ngIf="item.eventStatus === 'Completed'">
                    No MSME Attended
                  </span>
                </ng-template>

                <!--<span *ngIf="item.update === 'Nothing'" style="color: red; font-weight: bold;">
        Document upload is currently unavailable.
      </span>
      <span *ngIf="item.update === 'Done'" style="color: green; font-weight: bold;">
        Document upload is done.
      </span>-->
              </td>
            </ng-container>
            <ng-container matColumnDef="viewFeedback">
              <th mat-header-cell *matHeaderCellDef> View Feedback </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                <button class="btn btn-primary btn-sm" (click)="onViewFeedback(item.uniqueEventId)"
                        *ngIf="item.submittedfeedback>0;  else showNothing">
                  <i class="bi bi-eye"></i><br />View Feedback
                </button>
                <ng-template #showNothing>
                  <span *ngIf="item.isEventDateGreaterThanToday;  else showFeebackMsg" style="color: red; font-weight: bold;">
                    <!--Future Event-->
                  </span>
                </ng-template>
                <ng-template #showFeebackMsg>
                  <span style="color: red; font-weight: bold;">
                    No Feedback Available
                  </span>
                </ng-template>
              </td>
            </ng-container>
            <!--Table Header and Rows-->
            <!--<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            Row shown when there is no matching data.
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
        </div>

        <mat-paginator #paginator
                       class="demo-paginator"
                       (page)="onPageChange($event)"
                       [length]="length"
                       [pageSize]="pageSize"
                       [disabled]="disabled"
                       [showFirstLastButtons]="showFirstLastButtons"
                       [pageSizeOptions]="pageSizeOptions"
                       [hidePageSize]="hidePageSize"
                       [pageIndex]="pageIndex"
                       aria-label="Select page">
        </mat-paginator>

      </div>

      <div *ngIf="currentView === 'calender'">
        <app-full-calender></app-full-calender>
      </div>

      <div *ngIf="currentView === 'block'" class="row">
        <div class="col-md-4 mb-2" *ngFor="let event of dataSource">
          <div class="event-block card p-3">
            <p><b>Component Name : </b>{{event.componentName}}</p>
            <p><b>Event Name : </b>{{ event.eventName }}</p>
            <!--<p><b>Date : </b>{{ transformDate(event.eventDate) | date:'dd/MM/yyyy' }}</p>-->
            <p><b>Date : </b>{{ event.eventDate | date:'dd/MM/yyyy' }}</p>
            <p><b>Time : </b>{{ event.time }}</p>

            <!--<p><b>Status:</b>{{ event.status}}</p>
          <p>On Spot Registration : {{event.id}}</p>-->
            <!--<button (click)="onEdit(event.uniqueEventId,event.proposalId)" class="btn btn-primary btn-sm">View</button>-->
            <p>
              <button *ngIf="event.uniqueEventId" (click)="onEdit(event.uniqueEventId,event.proposalId)" class="btn btn-primary btn-sm">
                <span *ngIf="checkDate(event.formattedEventDate); else viewText">Edit</span>
                <ng-template #viewText>
                  <span><i class="bi bi-eye"></i> View</span>
                </ng-template>
              </button>
            </p>
          </div>
        </div>

        <mat-paginator #paginator
                       class="demo-paginator"
                       (page)="onCardPageChange($event)"
                       [length]="length1"
                       [pageSize]="pageSize1"
                       [disabled]="disabled1"
                       [showFirstLastButtons]="showFirstLastButtons1"
                       [pageSizeOptions]="pageSizeOptions1"
                       [hidePageSize]="hidePageSize1"
                       [pageIndex]="pageIndex1"
                       aria-label="Select page">
        </mat-paginator>
      </div>

    </div>

    <!-- Inline Popup Template -->

    <ng-template #myPopup>
      <h1 mat-dialog-title>Live Event URL</h1>
      <div mat-dialog-content>
        <div class="row mb-1">
          <div class="col-md-12">

            <!-- Hidden Input Field -->
            <!--<input type="hidden" formControlName="hiddenValue">-->

            <label for="implementationAgency">Event URL</label>
            <input type="text" class="form-control" formControlName="liveEventURL" placeholder="Enter live event url" >
          </div>
        </div>
        <div class="row">
          <div mat-dialog-actions class="action-buttons">
            <button *ngIf="popupSubmit" mat-raised-button color="primary" (click)="updateURL()">Submit</button>
            <button mat-button mat-dialog-close>Close</button>
          </div>
        </div>
      </div>
    </ng-template>




  </form>
</div>

